import { Panel } from "@/components/admin/AdminUI";
import { formatDate } from "@/lib/format";

// Count and last warning come only from GET /admin/users/{id} (user.warnings_count, user.last_warned_at).
// "…" while it loads, "—" when the server gave no count; 0 only when the server says 0.
export default function WarningsFact({ user, loading }) {
  const count = user?.warnings_count;
  const known = typeof count === "number";
  const last = user?.last_warned_at;
  const countText = loading ? "…" : known ? count : "—";
  const lastText = loading ? "…" : !known ? "—" : last ? formatDate(last) : "Never";
  return (
    <Panel className="p-6" data-testid="user-warnings-panel" aria-busy={loading || undefined}>
      <h2 className="mb-4 font-semibold">Warnings</h2>
      <dl className="grid gap-x-8 gap-y-4 text-sm sm:grid-cols-2">
        <div><dt className="cw-muted text-xs">Warnings sent</dt><dd className="mt-1 text-lg font-semibold tabular-nums" data-testid="user-warnings-count">{countText}</dd></div>
        <div><dt className="cw-muted text-xs">Last warned</dt><dd className="mt-1" data-testid="user-last-warned">{lastText}</dd></div>
      </dl>
    </Panel>
  );
}
